import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { resolveAppVersion } from 'src/utils/Services/app-version.service';

import AppPointPay from './app-pointpay';
import { SplashScreen } from './components/loading-screen';
import { installGlobalErrorHandlers } from './utils/boot/global-error-handlers';

// ----------------------------------------------------------------------

installGlobalErrorHandlers();

resolveAppVersion().catch(() => undefined);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense fallback={<SplashScreen />}>
        <AppPointPay />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
